import { BillingDetails, CamelCaseKeys, CardVendorEnum, UserBilling } from '@uplift/types';
import { restClient } from '../client';
import { Payment } from './admin';


export type ClientCard = {
  brand: keyof typeof CardVendorEnum;
  last4: string;
  expire: boolean;
  expirationDays: number;
  country: string;
  funding: string;
  expYear: number;
  expMonth: number;
  declined: boolean;
  billingDetails: BillingDetails;
  billing: UserBilling;
  outstandingBalanceCents: number;
  outstandingPaymentsCount: number;
  outstandingPayments: Payment[];
  declinedPaymentsCount: number;
  autopayEnabled: boolean;
  lastCompletedPaymentAt: string;
};


export type CheckBillingCardOutput = CamelCaseKeys<{
  error?: string;
  card: ClientCard;
}>;


export const checkBillingCard = () => {
  return restClient.request<CheckBillingCardOutput>('/payment/card/check', { method: 'POST' });
};
